/* WEARTH_VARIANT_PHASE1_START */
(function () {
  var PHASE = '32';

  function pixelMoneyNumber(value, opts) {
    opts = opts || {};
    if (value === null || value === undefined || value === '') return undefined;
    if (typeof value === 'number') {
      if (!isFinite(value)) return undefined;
      var amount = opts.cents ? value / 100 : value;
      return Math.round(amount * 100) / 100;
    }
    var num = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    if (!isFinite(num)) return undefined;
    return Math.round(num * 100) / 100;
  }
  var cartEnhancePaused = 0;
  var cartEnhanceSnapshot = '';
  var latestCartSnapshot = null;
  var sheet;
  var activeCard;
  var activeColor = '';
  var activeSize = '';
  var activeVariants = [];

  var productCache = {};
  /* WEARTH_PERF_CART_V31 */
  var cartEnhanceTimer = null;
  var cartEnhanceInFlight = false;

  function runWhenIdle(fn, timeoutMs) {
    timeoutMs = timeoutMs || 1200;
    if (typeof window.requestIdleCallback === 'function') {
      return window.requestIdleCallback(fn, { timeout: timeoutMs });
    }
    return window.setTimeout(fn, 16);
  }

  function scheduleCartEnhance(force) {
    if (cartEnhanceTimer) window.clearTimeout(cartEnhanceTimer);
    cartEnhanceTimer = window.setTimeout(function () {
      cartEnhanceTimer = null;
      enhanceCartFromSnapshot(force);
    }, force ? 60 : 350);
  }
  var cardHeroVideoIO = new WeakMap();

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function parseVariants(card) {
    var node = card.querySelector('.wearth-phase1-variants-json');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function productUrl(card) {
    return card.getAttribute('data-product-url') || '';
  }

  function variantUrl(card, variantId) {
    var base = productUrl(card);
    if (!base || !variantId) return base;
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variantId;
  }

  function setCardColor(card, dot) {
    if (!card || !dot) return;
    var color = dot.getAttribute('data-color') || '';
    var variantId = dot.getAttribute('data-variant-id') || '';
    var staticCard = card.classList.contains('wearth-phase1-card--static-image');
    card.setAttribute('data-active-color', color);
    card.setAttribute('data-active-variant-id', variantId);

    card.querySelectorAll('[data-wearth-phase1-color-dot]').forEach(function (btn) {
      var active = btn === dot;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var img = card.querySelector('[data-wearth-phase1-image]');
    var cardImageSrc = dot.getAttribute('data-image-src') || '';
    /* WEARTH_MOTION_TEE_CARD_MODEL_JS: catalogue model shot (-02), not -01 fabric */
    if (card.getAttribute('data-product-handle') === 'men-raglan-tshirt') {
      var blackHero = card.getAttribute('data-wearth-mt-black-src') || '';
      if (colorsMatch(color, 'Black') && blackHero) {
        cardImageSrc = blackHero;
      } else if (cardImageSrc && /-01(\.|_|\?)/.test(cardImageSrc)) {
        cardImageSrc = cardImageSrc.replace(/-01(\.|_)/, '-02$1');
      }
    }
    /* WEARTH_MEN_STATIC_CARD_COLOR_SWAP: static-image cards use dot data-image-src only */
    if (img && (!staticCard || cardImageSrc)) {
      card._wearthJoggersAngleIndex = 0;
      var colorKey = String(color || '').trim();
      var jUrls =
        card.getAttribute('data-wearth-joggers-multiview') === '1' && card._wearthJoggersUrlsByColor && colorKey
          ? card._wearthJoggersUrlsByColor[colorKey]
          : null;
      if (jUrls && jUrls.length) {
        joggersSetMainImage(card, jUrls[0]);
        card.classList.toggle('wearth-phase1-joggers--multi-angle', jUrls.length > 1);
      } else {
        var src = cardImageSrc || dot.getAttribute('data-image-src');
        var srcset = dot.getAttribute('data-image-srcset');
        if (card.getAttribute('data-product-handle') === 'men-raglan-tshirt' && srcset && srcset.indexOf('-01') !== -1) {
          srcset = srcset.replace(/-01(\.|_| )/g, '-02$1');
        }
        if (src) {
          img.classList.add('wearth-phase1-image--changing');
          img.setAttribute('src', src);
          if (srcset) img.setAttribute('srcset', srcset);
          window.setTimeout(function () {
            img.classList.remove('wearth-phase1-image--changing');
          }, 180);
        } else if (srcset) {
          img.setAttribute('srcset', srcset);
        }
        if (card.getAttribute('data-wearth-joggers-multiview') === '1') {
          card.classList.remove('wearth-phase1-joggers--multi-angle');
        }
      }
    }

    var href = variantUrl(card, variantId);
    card.querySelectorAll('[data-wearth-phase1-link]').forEach(function (link) {
      link.setAttribute('href', href);
    });

    updateSwipeHint(card);
    syncCardHeroVideo(card, color, dot);
  }

  function getColorDots(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-wearth-phase1-color-dot]'));
  }

  function stepCardColor(card, delta) {
    var dots = getColorDots(card);
    if (dots.length < 2) return;

    var activeIndex = dots.findIndex(function (dot) {
      return dot.classList.contains('is-active');
    });
    if (activeIndex < 0) activeIndex = 0;

    var nextIndex = activeIndex + delta;
    if (nextIndex < 0) nextIndex = dots.length - 1;
    if (nextIndex >= dots.length) nextIndex = 0;

    setCardColor(card, dots[nextIndex]);
    card.setAttribute('data-wearth-phase1-swiped', 'true');
  }

  function ensureSwipeHint(card) {
    var media = card.querySelector('[data-wearth-phase1-media]');
    if (!media || media.querySelector('[data-wearth-phase1-swipe-hint]')) return;

    var hint = document.createElement('button');
    hint.type = 'button';
    hint.className = 'wearth-phase1-color-swipe-hint';
    hint.setAttribute('data-wearth-phase1-swipe-hint', '');
    hint.setAttribute('aria-label', 'More colours');
    hint.innerHTML =
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path d="M8 5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>';
    hint.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      stepCardColor(card, 1);
    });
    media.appendChild(hint);
  }

  function updateSwipeHint(card) {
    var dots = getColorDots(card);
    var hint = card.querySelector('[data-wearth-phase1-swipe-hint]');
    card.classList.toggle('is-color-swipeable', dots.length >= 2);

    if (!hint) return;

    if (dots.length < 2 || card.getAttribute('data-wearth-phase1-swiped') === 'true') {
      hint.classList.remove('is-visible');
      return;
    }

    var activeIndex = dots.findIndex(function (dot) {
      return dot.classList.contains('is-active');
    });
    hint.classList.toggle('is-visible', activeIndex >= 0 && activeIndex < dots.length - 1);
  }

  function attachColorSwipe(card) {
    var media = card.querySelector('[data-wearth-phase1-media]');
    if (!media || media.getAttribute('data-wearth-phase1-swipe') === 'true') return;
    media.setAttribute('data-wearth-phase1-swipe', 'true');

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var threshold = 40;

    function onTouchStart(event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }

    function onTouchMove(event) {
      if (!tracking || event.touches.length !== 1) return;
      var dx = event.touches[0].clientX - startX;
      var dy = event.touches[0].clientY - startY;
      if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function onTouchEnd(event) {
      if (!tracking) return;
      tracking = false;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
      event.preventDefault();
      event.stopPropagation();
      stepCardColor(card, dx < 0 ? 1 : -1);
    }

    media.addEventListener('touchstart', onTouchStart, { passive: true });
    media.addEventListener('touchmove', onTouchMove, { passive: false });
    media.addEventListener('touchend', onTouchEnd, { passive: false });
  }

  function optionKeys(card) {
    return {
      color: card.getAttribute('data-color-option') || 'option1',
      size: card.getAttribute('data-size-option') || 'option2',
    };
  }

  function variantOptionValue(variant, key) {
    if (!variant || !key) return '';
    return variant[key] || '';
  }

  function sizesForColor(variants, color, keys) {
    var out = [];
    variants.forEach(function (variant) {
      if (!variant || String(variantOptionValue(variant, keys.color)) !== String(color)) return;
      out.push({
        size: variantOptionValue(variant, keys.size) || variant.title,
        id: variant.id,
        available: !!variant.available,
      });
    });
    return out;
  }

  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'wearth-phase1-size-sheet';
    sheet.innerHTML =
      '<div class="wearth-phase1-size-sheet__backdrop" data-wearth-phase1-close></div>' +
      '<div class="wearth-phase1-size-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="wearth-phase1-size-title">' +
      '<p class="wearth-phase1-size-sheet__title" id="wearth-phase1-size-title">Choose your size</p>' +
      '<p class="wearth-phase1-size-sheet__meta" data-wearth-phase1-size-meta></p>' +
      '<div class="wearth-phase1-size-options" data-wearth-phase1-size-options></div>' +
      '<div class="wearth-phase1-size-sheet__actions">' +
      '<button type="button" class="wearth-phase1-size-sheet__cancel" data-wearth-phase1-close>Cancel</button>' +
      '<button type="button" class="wearth-phase1-size-sheet__confirm" data-wearth-phase1-confirm disabled>Add to cart</button>' +
      '</div>' +
      '<p class="wearth-phase1-size-sheet__error" data-wearth-phase1-size-error></p>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.querySelectorAll('[data-wearth-phase1-close]').forEach(function (node) {
      node.addEventListener('click', closeSheet);
    });
    sheet.querySelector('[data-wearth-phase1-confirm]').addEventListener('click', confirmAdd);
  }

  function openSheet(card, color) {
    ensureSheet();
    activeCard = card;
    activeColor = color || resolvedColorForCard(card);
    activeSize = '';
    activeVariants = parseVariants(card);

    var title = card.querySelector('.card__heading a');
    var meta = sheet.querySelector('[data-wearth-phase1-size-meta]');
    meta.textContent = (title ? title.textContent.trim() : 'Product') + (activeColor ? ' · ' + activeColor : '');

    var options = sheet.querySelector('[data-wearth-phase1-size-options]');
    options.innerHTML = '';
    var keys = inferOptionKeys(card, activeVariants);
    var sizes = sizesForColor(activeVariants, activeColor, keys);
    if (!sizes.length) {
      sheet.querySelector('[data-wearth-phase1-size-error]').textContent = 'No sizes available for this color.';
      sheet.querySelector('[data-wearth-phase1-confirm]').disabled = true;
      sheet.classList.add('is-open');
      document.documentElement.classList.add('wearth-phase1-sheet-open');
      return;
    }
    sizes.forEach(function (entry) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wearth-phase1-size-option';
      btn.textContent = entry.size;
      btn.disabled = !entry.available;
      btn.setAttribute('data-variant-id', entry.id);
      btn.setAttribute('data-size', entry.size);
      btn.addEventListener('click', function () {
        activeSize = entry.size;
        options.querySelectorAll('.wearth-phase1-size-option').forEach(function (node) {
          node.classList.toggle('is-active', node === btn);
        });
        sheet.querySelector('[data-wearth-phase1-confirm]').disabled = false;
        sheet.querySelector('[data-wearth-phase1-size-error]').textContent = '';
      });
      options.appendChild(btn);
    });

    sheet.querySelector('[data-wearth-phase1-confirm]').disabled = true;
    sheet.querySelector('[data-wearth-phase1-size-error]').textContent = '';
    sheet.classList.add('is-open');
    document.documentElement.classList.add('wearth-phase1-sheet-open');

    if (sizes.length === 1 && sizes[0].available) {
      options.querySelector('.wearth-phase1-size-option').click();
    }
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('wearth-phase1-sheet-open');
    activeCard = null;
    activeColor = '';
    activeSize = '';
    activeVariants = [];
  }

  function refreshCartDrawer() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      return;
    }
    if (window.mono && window.mono.RightDrawer && typeof window.mono.RightDrawer.open === 'function') {
      window.mono.RightDrawer.open();
    }
  }

  function detectAddSurface(card, sourceEl) {
    if (card) {
      if (card.closest('.one_time, .wearth-phase1-cart-upsell')) return 'cart_pairing';
      if (card.closest('.recently-viewed-grid, .recently_viewed, .rv-section-products')) return 'recently_viewed';
      if (card.closest('.product-recommendations, .complementary_product, #productRecommendationsSection')) {
        return 'pdp_recommendations';
      }
      if (document.body.classList.contains('template-index')) return 'home_card';
      if (document.body.classList.contains('template-collection')) return 'collection_card';
      if (document.body.classList.contains('template-product')) return 'pdp_card';
      return 'card';
    }

    var form = sourceEl && sourceEl.closest ? sourceEl.closest('form[action*="/cart/add"]') : null;
    if (form) {
      if (form.closest('.wearth-sticky-checkout, .stickyCart')) return 'pdp_sticky';
      if (form.closest('product-form, .product-form')) return 'pdp_main';
    }
    if (document.body.classList.contains('template-product')) return 'pdp_main';
    return 'unknown';
  }

  function publishShopifyAddToCart(lineItem, detail) {
    try {
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
        return;
      }
      var variantId = lineItem.variant_id || lineItem.id;
      var amount = pixelMoneyNumber(detail.price, { cents: true }) || 0;
      window.Shopify.analytics.publish('product_added_to_cart', {
        cartLine: {
          cost: {
            totalAmount: {
              amount: amount,
              currencyCode: detail.currency || 'SGD',
            },
          },
          merchandise: {
            id: String(variantId),
            product: {
              id: String(lineItem.product_id || ''),
              title: detail.title || '',
            },
            quantity: detail.quantity || 1,
          },
        },
        wearthSurface: detail.surface,
      });
    } catch (e) {
      /* noop */
    }
  }

  function trackAddToCartLine(lineItem, card, sourceEl) {
    if (!lineItem || lineItem._wearthPhase1Tracked) return;
    lineItem._wearthPhase1Tracked = true;

    var variantId = lineItem.variant_id || lineItem.id;
    var surface = detectAddSurface(card, sourceEl);
    var detail = {
      variantId: variantId,
      productId: lineItem.product_id,
      quantity: lineItem.quantity || 1,
      price: lineItem.price,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD',
      title: lineItem.title,
      source: card ? card.getAttribute('data-product-handle') : '',
      surface: surface,
    };

    document.dispatchEvent(new CustomEvent('wearth:addToCart', { bubbles: true, detail: detail }));
    document.documentElement.dispatchEvent(
      new CustomEvent('product:added-to-cart', {
        bubbles: true,
        detail: { variant: { id: variantId }, quantity: detail.quantity, surface: surface },
      })
    );

    publishShopifyAddToCart(lineItem, detail);

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'add_to_cart');
      window.clarity('set', 'wearth_atc_surface', surface);
    }
  }

  function trackBeginCheckout(surface) {
    if (window._wearthBeginCheckoutTracked) return;
    window._wearthBeginCheckoutTracked = true;
    window.setTimeout(function () {
      window._wearthBeginCheckoutTracked = false;
    }, 4000);

    var cart = latestCartSnapshot;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD';
    var items = cart && cart.items ? cart.items : [];
    var contents = items.map(function (item) {
      return { id: String(item.variant_id), quantity: item.quantity };
    });
    var contentIds = contents.map(function (entry) {
      return entry.id;
    });
    var value = pixelMoneyNumber(cart && cart.total_price, { cents: true });
    var detail = {
      surface: surface || 'cart_drawer',
      currency: currency,
      value: value,
      numItems: cart ? cart.item_count : 0,
      contentIds: contentIds,
      contents: contents,
    };

    document.dispatchEvent(new CustomEvent('wearth:beginCheckout', { bubbles: true, detail: detail }));

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('checkout_started', {
          wearthSurface: detail.surface,
          currency: detail.currency,
          value: detail.value,
          numItems: detail.numItems,
        });
      }
    } catch (e) {
      /* noop */
    }

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'begin_checkout');
      window.clarity('set', 'wearth_checkout_surface', detail.surface);
    }
  }

  function initCheckoutRecovery() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(
          '.ajaxcart .cart__checkout, .cart__checkout[name="checkout"], button[name="checkout"], #checkout'
        );
        if (!button) return;
        setCheckoutBlocked(false);
        button.disabled = false;
        button.classList.remove('wearth-phase1-checkout-blocked');
      },
      true
    );
  }

  function initCheckoutTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.ajaxcart .cart__checkout, .cart__checkout[name="checkout"]');
        if (!button || button.disabled || button.classList.contains('wearth-phase1-checkout-blocked')) return;
        trackBeginCheckout('cart_drawer');
      },
      true
    );
  }

  function browsePageType() {
    if (document.body.classList.contains('template-product')) return 'product';
    if (document.body.classList.contains('template-collection')) return 'collection';
    if (document.body.classList.contains('template-index')) return 'home';
    return 'other';
  }

  function readCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readProductContext() {
    var root = document.querySelector('variant-radios[data-product], variant-selects[data-product]');
    var productId = root ? root.getAttribute('data-product') || '' : '';
    var script = document.querySelector('script[id^="ProductJSON-"]');
    var product = null;
    if (script) {
      try {
        product = JSON.parse(script.textContent || '{}');
      } catch (e) {
        product = null;
      }
    }
    var variantInput = mainVariantInput();
    var variantId = variantInput && variantInput.value ? String(variantInput.value) : '';
    var variant = null;
    if (product && product.variants && variantId) {
      variant = product.variants.find(function (entry) {
        return String(entry.id) === variantId;
      });
    }
    if (!variant && product && product.variants && product.variants.length) {
      variant = product.variants[0];
      variantId = variant ? String(variant.id) : variantId;
    }
    return {
      productId: productId || (product && product.id ? String(product.id) : ''),
      handle: (product && product.handle) || '',
      title: (product && product.title) || '',
      variantId: variantId,
      price: variant && variant.price ? variant.price : undefined,
    };
  }

  function publishShopifyBrowse(eventName, detail) {
    try {
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
        return;
      }
      window.Shopify.analytics.publish(eventName, detail);
    } catch (e) {
      /* noop */
    }
  }

  function trackBrowseView() {
    if (!window._wearthBrowseTracked) window._wearthBrowseTracked = {};
    var pageType = browsePageType();
    var key = pageType + ':' + window.location.pathname;
    if (window._wearthBrowseTracked[key]) return;
    window._wearthBrowseTracked[key] = true;

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD';
    var detail = {
      pageType: pageType,
      path: window.location.pathname,
      currency: currency,
    };

    if (pageType === 'product') {
      var product = readProductContext();
      detail.productId = product.productId;
      detail.handle = product.handle;
      detail.title = product.title;
      detail.variantId = product.variantId;
      detail.value = pixelMoneyNumber(product.price, { cents: true });

      document.dispatchEvent(new CustomEvent('wearth:viewContent', { bubbles: true, detail: detail }));
      publishShopifyBrowse('product_viewed', {
        wearthSurface: 'pdp',
        productId: detail.productId,
        variantId: detail.variantId,
        title: detail.title,
      });

      if (typeof window.clarity === 'function') {
        window.clarity('event', 'view_product');
        window.clarity('set', 'wearth_page_type', 'product');
      }
      return;
    }

    if (pageType === 'collection') {
      detail.collectionHandle = readCollectionHandle();
      document.dispatchEvent(new CustomEvent('wearth:viewCollection', { bubbles: true, detail: detail }));
      publishShopifyBrowse('collection_viewed', {
        wearthSurface: 'collection',
        collectionHandle: detail.collectionHandle,
      });

      if (typeof window.clarity === 'function') {
        window.clarity('event', 'view_collection');
        window.clarity('set', 'wearth_page_type', 'collection');
      }
      return;
    }

    if (pageType === 'home') {
      document.dispatchEvent(new CustomEvent('wearth:viewHome', { bubbles: true, detail: detail }));
      publishShopifyBrowse('page_viewed', { wearthSurface: 'home' });

      if (typeof window.clarity === 'function') {
        window.clarity('event', 'view_home');
        window.clarity('set', 'wearth_page_type', 'home');
      }
    }
  }

  function initBrowseTracking() {
    trackBrowseView();
  }

  function reinitPairingCarousel(root) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
    window.jQuery(root || document)
      .find('.one_time')
      .each(function () {
        var $el = window.jQuery(this);
        if (!$el.children().length) return;
        if ($el.hasClass('slick-initialized')) {
          $el.slick('unslick');
        }
        $el.slick({
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          slidesToScroll: 1,
        });
      });
  }

  function handleCartDrawerReady(_evt, cart) {
    setCheckoutBlocked(false);
    if (cart && cart.items) latestCartSnapshot = cart;
    var root = document.getElementById('CartContainer') || document;
    initAllCards(root);
    scheduleCartEnhance(false);
    syncFirstSetBundleNudge(latestCartSnapshot || cart);
    runWhenIdle(function () {
      reinitPairingCarousel(root);
    }, 2000);
  }

  function confirmAdd() {
    if (!activeCard || !activeColor || !activeSize) return;
    var keys = inferOptionKeys(activeCard, activeVariants);
    var match = sizesForColor(activeVariants, activeColor, keys).find(function (entry) {
      return entry.size === activeSize;
    });
    if (!match) {
      sheet.querySelector('[data-wearth-phase1-size-error]').textContent = 'Choose a size to continue.';
      return;
    }

    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    var confirmBtn = sheet.querySelector('[data-wearth-phase1-confirm]');
    confirmBtn.disabled = true;

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(match.id), quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (lineItem) {
        trackAddToCartLine(lineItem, activeCard);
        closeSheet();
        refreshCartDrawer();
      })
      .catch(function (error) {
        var message = (error && (error.description || error.message)) || 'Could not add this size. Try again.';
        sheet.querySelector('[data-wearth-phase1-size-error]').textContent = message;
        confirmBtn.disabled = false;
      });
  }

  function resolvedColorForCard(card) {
    var variants = parseVariants(card);
    if (!variants.length) return card.getAttribute('data-default-color') || '';

    var keys = inferOptionKeys(card, variants);
    var activeDot = card.querySelector('[data-wearth-phase1-color-dot].is-active');
    if (activeDot) return activeDot.getAttribute('data-color') || '';

    var colors = uniqueColors(variants, keys.color).filter(function (color) {
      return colorIsCardSelectable(variants, keys, color);
    });
    if (colors.length) return colors[0];

    return variantOptionValue(variants[0], keys.color) || card.getAttribute('data-default-color') || '';
  }

  function wearthMultiSize(card) {
    var variants = parseVariants(card);
    if (!variants.length) return false;
    var sizeKeys = ['option1', 'option2', 'option3'].filter(function (key) {
      var values = optionValueSet(variants, key);
      return values.length > 0 && values.every(looksLikeSize);
    });
    return sizeKeys.length > 1;
  }

  function bindCardAddToCart(card) {
    var atc = card.querySelector('[data-wearth-phase1-atc]');
    if (!atc || atc.getAttribute('data-wearth-phase1-atc-bound') === 'true') return;
    atc.setAttribute('data-wearth-phase1-atc-bound', 'true');
    atc.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      /* WEARTH_HEARTWOOD_FIX_20261009: a set sized apart cannot be chosen in a one-size sheet */
      if (wearthMultiSize(card)) {
        var wearthLink = card.querySelector('[data-wearth-phase1-link]') || card.querySelector('.card__heading a') || card.querySelector('a[href*="/products/"]');
        if (wearthLink && wearthLink.getAttribute('href')) {
          window.location.href = wearthLink.getAttribute('href');
          return;
        }
      }
      openSheet(card, resolvedColorForCard(card));
    });
  }

  function variantHasCardMedia(variant) {
    return !!(variant && variant.featured_image && variant.featured_image.src);
  }

  function colorIsCardSelectable(variants, keys, color, dot) {
    var entries = variants.filter(function (variant) {
      return String(variantOptionValue(variant, keys.color)) === String(color);
    });
    if (!entries.length) return false;
    if (!entries.some(function (variant) { return !!variant.available; })) return false;
    if (entries.some(function (variant) { return variantHasCardMedia(variant); })) return true;
    /* WEARTH_COLOR_DOT_DATA_IMG: liquid may set data-image-src from CARD/PDP alts without variant.featured_image */
    if (dot && (dot.getAttribute('data-image-src') || dot.getAttribute('data-image-srcset'))) return true;
    return entries.some(function (variant) { return !!variant.available; });
  }

  function normalizeColorRail(card) {
    var variants = parseVariants(card);
    if (!variants.length) return;

    var keys = inferOptionKeys(card, variants);
    card.querySelectorAll('[data-wearth-phase1-color-dot]').forEach(function (dot) {
      var color = dot.getAttribute('data-color') || '';
      if (!colorIsCardSelectable(variants, keys, color, dot)) dot.remove();
    });
  }

  function syncSingleColorUi(card) {
    var dots = getColorDots(card);
    card.classList.toggle('is-single-color', dots.length <= 1);
    if (dots.length === 1 && !card.classList.contains('wearth-phase1-card--static-image')) {
      setCardColor(card, dots[0]);
    }
  }

  function uniqueColors(variants, colorKey) {
    var colors = [];
    variants.forEach(function (variant) {
      var color = variantOptionValue(variant, colorKey);
      if (!color) return;
      if (colors.indexOf(color) < 0) colors.push(color);
    });
    return colors;
  }

  function looksLikeSize(value) {
    var normalized = String(value || '').trim();
    if (!normalized) return false;
    if (/^(XXS|XS|S|M|L|XL|XXL|2XL|3XL|OS|ONE\s*SIZE|ONESIZE)$/i.test(normalized)) return true;
    if (/^(x-?s|x-?l|xx-?s|xx-?l)$/i.test(normalized)) return true;
    return /^\d+(\.\d+)?$/.test(normalized);
  }

  function optionValueSet(variants, key) {
    var values = [];
    variants.forEach(function (variant) {
      var value = variantOptionValue(variant, key);
      if (!value) return;
      if (values.indexOf(String(value)) < 0) values.push(String(value));
    });
    return values;
  }

  function inferKeysFromVariants(variants, hinted) {
    var keys = hinted || { color: 'option1', size: 'option2' };
    if (!variants.length) return keys;

    var optionKeysList = ['option1', 'option2', 'option3'].filter(function (key) {
      return variants.some(function (variant) {
        return !!variantOptionValue(variant, key);
      });
    });
    if (optionKeysList.length < 2) return keys;

    var scored = optionKeysList
      .map(function (key) {
        var values = optionValueSet(variants, key);
        var sizeScore = values.filter(looksLikeSize).length;
        return { key: key, sizeScore: sizeScore, count: values.length };
      })
      .sort(function (a, b) {
        return b.sizeScore - a.sizeScore || b.count - a.count;
      });

    var sizeKey = scored[0].sizeScore > 0 ? scored[0].key : keys.size;
    var colorKey = optionKeysList.filter(function (key) {
      return key !== sizeKey;
    })[0];
    if (!colorKey) colorKey = keys.color;
    if (sizeKey === colorKey) return keys;
    return { color: colorKey, size: sizeKey };
  }

  function inferOptionKeys(card, variants) {
    var keys = inferKeysFromVariants(variants, optionKeys(card));
    card.setAttribute('data-color-option', keys.color);
    card.setAttribute('data-size-option', keys.size);
    return keys;
  }

  function pdpAltImageForColor(product, color) {
    if (!product || !color) return '';
    var alts = [
      'PDP:' + color + '-02',
      'PDP:' + color + '-03',
      'PDP:' + color + '-01',
      'PDP:' + color,
      'CARD:' + color
    ];
    var media = product.media || product.images || [];
    for (var a = 0; a < alts.length; a += 1) {
      var want = alts[a];
      for (var i = 0; i < media.length; i += 1) {
        var entry = media[i];
        var alt = (entry && (entry.alt || entry.alt_text)) || '';
        if (alt === want) {
          return (
            (entry.preview_image && entry.preview_image.src) ||
            (entry.preview && entry.preview.src) ||
            entry.src ||
            ''
          );
        }
      }
    }
    return '';
  }

  function ensureColorDots(card) {
    var variants = parseVariants(card);
    if (!variants.length) return;

    var keys = inferOptionKeys(card, variants);
    var colors = uniqueColors(variants, keys.color);
    if (!colors.length) return;

    var rail = card.querySelector('[data-wearth-phase1-color-rail]');
    if (!rail) return;

    var defaultColor = card.getAttribute('data-default-color') || '';
    if (!colors.some(function (color) { return String(color) === String(defaultColor); })) {
      defaultColor = colors[0];
      card.setAttribute('data-default-color', defaultColor);
    }

    var handle = card.getAttribute('data-product-handle') || '';
    var productPromise = null;

    colors.forEach(function (color) {
      if (rail.querySelector('[data-wearth-phase1-color-dot][data-color="' + color.replace(/"/g, '\"') + '"]')) return;

      var scratch = document.createElement('button');
      scratch.setAttribute('data-color', color);
      if (!colorIsCardSelectable(variants, keys, color, scratch)) return;

      var variant =
        variants.find(function (entry) {
          return String(variantOptionValue(entry, keys.color)) === String(color) && entry.available;
        }) ||
        variants.find(function (entry) {
          return String(variantOptionValue(entry, keys.color)) === String(color);
        });
      if (!variant) return;

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wearth-phase1-color-dot';
      dot.setAttribute('data-wearth-phase1-color-dot', '');
      dot.setAttribute('data-color', color);
      dot.setAttribute('data-variant-id', variant.id);
      if (variant.featured_image && variant.featured_image.src) {
        dot.setAttribute('data-image-src', variant.featured_image.src);
      }
      if (String(color) === String(defaultColor)) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-pressed', 'true');
      } else {
        dot.setAttribute('aria-pressed', 'false');
      }
      dot.setAttribute('aria-label', color);

      var label = document.createElement('span');
      label.className = 'wearth-phase1-color-dot__label';
      label.textContent = color;
      dot.appendChild(label);
      rail.appendChild(dot);

      /* WEARTH_ENSURE_COLOR_DOTS_FILL: fill data-image-src from product.media alts when variant has no image */
      if (!dot.getAttribute('data-image-src') && handle) {
        if (!productPromise) productPromise = fetchProduct(handle);
        productPromise.then(function (product) {
          var src = pdpAltImageForColor(product, color);
          if (src) dot.setAttribute('data-image-src', src);
        });
      }
    });
  }

  function initCard(card) {
    if (card.getAttribute('data-wearth-phase1-bound') === 'true') return;

    ensureColorDots(card);
    normalizeColorRail(card);
    if (card.getAttribute('data-product-handle') === 'men-raglan-tshirt') {
      card.querySelectorAll('[data-wearth-phase1-color-dot]').forEach(function (dot) {
        var src = dot.getAttribute('data-image-src') || '';
        if (/-01(\.|_|\?)/.test(src)) {
          dot.setAttribute('data-image-src', src.replace(/-01(\.|_)/, '-02$1'));
        }
        var srcset = dot.getAttribute('data-image-srcset') || '';
        if (srcset.indexOf('-01') !== -1) {
          dot.setAttribute('data-image-srcset', srcset.replace(/-01(\.|_| )/g, '-02$1'));
        }
      });
    }
    var dots = Array.prototype.slice.call(card.querySelectorAll('[data-wearth-phase1-color-dot]'));
    if (!dots.length) {
      card.setAttribute('data-wearth-phase1-bound', 'true');
      syncSingleColorUi(card);
      bindCardAddToCart(card);
      return;
    }

    card.setAttribute('data-wearth-phase1-bound', 'true');

    var initial = card.querySelector('[data-wearth-phase1-color-dot].is-active') || dots[0];
    /* WEARTH_MOTION_TEE_BLACK_INIT_SYNC: static cards sync explicit swatch hero on init */
    if (!card.classList.contains('wearth-phase1-card--static-image')) {
      setCardColor(card, initial);
    } else if (initial.getAttribute('data-image-src')) {
      setCardColor(card, initial);
    } else {
      card.setAttribute('data-active-color', initial.getAttribute('data-color') || '');
      card.setAttribute('data-active-variant-id', initial.getAttribute('data-variant-id') || '');
    }
    syncSingleColorUi(card);
    dots = getColorDots(card);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setCardColor(card, dot);
      });
    });

    bindCardAddToCart(card);

    if (dots.length >= 2) {
      ensureSwipeHint(card);
      attachColorSwipe(card);
      updateSwipeHint(card);
    }

    if (card.getAttribute('data-wearth-joggers-multiview') === '1') {
      applyJoggersSwatchFix(card);
      initJoggersMultiview(card);
    }
    if (card.getAttribute('data-wearth-card-has-video') === '1') {
      applyJoggersSwatchFix(card);
      initCardHeroVideo(card);
    }
  }

  function mainProductAddForm() {
    return document.querySelector(
      'product-form form[action*="/cart/add"], form.product-form[action*="/cart/add"]:not(.wearth-sticky-checkout__form)'
    );
  }

  function submitMainProductAdd() {
    resolveVariantIdForSubmit();
    var mainForm = mainProductAddForm();
    if (!mainForm) return false;
    if (typeof mainForm.requestSubmit === 'function') {
      mainForm.requestSubmit();
      return true;
    }
    mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    return true;
  }

  function mainVariantInput() {
    return document.querySelector('product-form form[action*="/cart/add"] input[name="id"], form.product-form input[name="id"]');
  }

  function variantRadiosEl() {
    return document.querySelector('variant-radios');
  }

  function variantDataFromPage() {
    var root = variantRadiosEl();
    if (!root) return [];
    try {
      return JSON.parse(root.querySelector('[type="application/json"]').textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function selectedOptionsFromRadios() {
    var root = variantRadiosEl();
    if (!root) return [];
    return Array.from(root.querySelectorAll('fieldset')).map(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : '';
    });
  }

  function variantIdFromSelections(options, variants) {
    var match = variants.find(function (variant) {
      if (!variant || !variant.options) return false;
      return variant.options.every(function (option, index) {
        return String(option) === String(options[index]);
      });
    });
    return match ? String(match.id) : '';
  }

  function currentMainVariantId() {
    var main = mainVariantInput();
    return main && main.value ? String(main.value) : '';
  }

  function syncAllVariantInputs(variantId) {
    if (!variantId) return;
    document
      .querySelectorAll(
        'product-form form[action*="/cart/add"] input[name="id"], form.product-form input[name="id"], .wearth-sticky-checkout input[name="id"], .sticky-id, input.sticky-id, #var_id'
      )
      .forEach(function (input) {
        input.value = variantId;
      });
  }

  function syncProductPageVariantState() {
    var options = selectedOptionsFromRadios();
    var variants = variantDataFromPage();
    var variantId = variantIdFromSelections(options, variants) || currentMainVariantId();
    if (variantId) syncAllVariantInputs(variantId);
    return variantId;
  }

  function resolveVariantIdForSubmit() {
    var options = selectedOptionsFromRadios();
    var variants = variantDataFromPage();
    var variantId = variantIdFromSelections(options, variants);
    if (!variantId) {
      syncColorFromActiveGallery();
      options = selectedOptionsFromRadios();
      variantId = variantIdFromSelections(options, variants);
    }
    if (variantId) syncAllVariantInputs(variantId);
    return variantId || currentMainVariantId();
  }

  function syncStickyCheckout() {
    syncProductPageVariantState();
  }

  function isMensJoggersPdp() {
    return /\/products\/(mens-everyday-joggers|the-off-duty-short)\/?$/i.test(window.location.pathname || '');
  }

  function isMenRaglanPdp() {
    return /\/products\/men-raglan-tshirt\/?$/i.test(window.location.pathname || '');
  }

  function isEdgeTankPdp() {
    return /\/products\/sleeveless-regular-fit-tshirt-men\/?$/i.test(window.location.pathname || '');
  }

  function productUsesPdpColorGallery() {
    return !!document.querySelector('[id^="GalleryViewer-"] img[alt^="PDP:"]');
  }

  function pdpColorFromAlt(alt) {
    if (!alt || alt.indexOf('PDP:') !== 0) return '';
    var rest = alt.slice(4);
    var dash = rest.lastIndexOf('-');
    if (dash >= 0 && /^\d{2}$/.test(rest.slice(dash + 1))) {
      rest = rest.slice(0, dash);
    }
    rest = rest.trim();
    if (!rest) return '';
    /* Set colourways keep exact Shopify option casing: "Olive + Black" */
    if (rest.indexOf(' + ') >= 0) return rest;
    if (rest.toUpperCase() === 'OLIVE') return 'OLIVE';
    return rest.charAt(0).toUpperCase() + rest.slice(1).toLowerCase();
  }

  function colorFromPdpSlideMediaId(mediaId) {
    if (!mediaId) return '';
    var slide = document.querySelector('[id^="GalleryViewer-"] [data-media-id="' + mediaId + '"]');
    if (!slide) return '';
    var img = slide.querySelector('img');
    var alt = (img && img.getAttribute('alt')) || '';
    if (alt.indexOf('PDP:') === 0) return pdpColorFromAlt(alt);
    return '';
  }

  function activateFirstPdpSlideForColor(colorValue) {
    if (!colorValue || !productUsesPdpColorGallery()) return;
    var tries = [
      'PDP:' + colorValue + '-02',
      'PDP:' + colorValue + '-03',
      'PDP:' + colorValue + '-01',
      'PDP:' + colorValue
    ];
    var img = null;
    for (var t = 0; t < tries.length; t += 1) {
      img =
        document.querySelector('[id^="GalleryViewer-"] img[alt^="' + tries[t] + '"]') ||
        document.querySelector('[id^="GalleryViewer-"] img[alt="' + tries[t] + '"]');
      if (img) break;
    }
    if (!img) return;
    var slide = img.closest('[data-media-id]');
    if (!slide || !slide.dataset.mediaId) return;
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(slide.dataset.mediaId, false);
    }
  }

  function colorValueFromMediaId(mediaId) {
    if (!mediaId) return '';
    var fromAlt = colorFromPdpSlideMediaId(mediaId);
    if (fromAlt) return fromAlt;
    var variants = variantDataFromPage();
    var variant = variants.find(function (entry) {
      return entry.featured_media && String(entry.featured_media.id) === String(mediaId);
    });
    if (!variant || !variant.options) return '';
    var root = variantRadiosEl();
    if (!root) return '';
    var colorIndex = Array.from(root.querySelectorAll('fieldset')).findIndex(function (fieldset) {
      return !!fieldset.querySelector('input.variant_name_color, input.variant_name_colourway');
    });
    if (colorIndex < 0) return '';
    return variant.options[colorIndex] || '';
  }

  function mediaIdFromGalleryTarget(target) {
    var item = target.closest('[data-target]');
    if (!item) return '';
    var targetId = item.getAttribute('data-target') || '';
    var match = targetId.match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function variantFromMediaId(mediaId) {
    if (!mediaId) return null;
    var variants = variantDataFromPage();
    return (
      variants.find(function (entry) {
        return entry.featured_media && String(entry.featured_media.id) === String(mediaId);
      }) || null
    );
  }

  function applyVariantOptions(options) {
    var root = variantRadiosEl();
    if (!root || !options || !options.length) return;
    Array.from(root.querySelectorAll('fieldset')).forEach(function (fieldset, index) {
      var value = options[index];
      if (!value) return;
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (String(input.value) === String(value)) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function syncFromGalleryThumbnail(target) {
    var mediaId = mediaIdFromGalleryTarget(target);
    if (!mediaId) return false;

    var color = colorValueFromMediaId(mediaId);
    if (color) {
      selectColorRadio(color);
      syncProductPageVariantState();
      return true;
    }

    return false;
  }

  function syncColorFromActiveGallery() {
    var active = document.querySelector('[id^="GalleryViewer-"] [data-media-id].is-active');
    if (!active) return;
    var color = colorValueFromMediaId(active.dataset.mediaId);
    if (color) selectColorRadio(color);
    syncProductPageVariantState();
  }

  function handleMediaGalleryChange(event) {
    if (!isProductPage()) return;
    if (event && event.detail && event.detail.currentElement) {
      var color = colorValueFromMediaId(event.detail.currentElement.dataset.mediaId);
      if (color) selectColorRadio(color);
      window.setTimeout(syncProductPageVariantState, 40);
      return;
    }
    syncColorFromActiveGallery();
  }

  function pauseCartEnhance() {
    cartEnhancePaused += 1;
  }

  function resumeCartEnhance() {
    window.setTimeout(function () {
      cartEnhancePaused = Math.max(0, cartEnhancePaused - 1);
    }, 250);
  }

  function cartSignature(cart) {
    return (cart.items || [])
      .map(function (item) {
        return [item.key, item.variant_id, item.quantity].join(':');
      })
      .join('|');
  }

  function bindCartSizeSelect(select, line, item) {
    select.addEventListener('focus', pauseCartEnhance);
    select.addEventListener('mousedown', pauseCartEnhance);
    select.addEventListener('touchstart', pauseCartEnhance, { passive: true });
    select.addEventListener('blur', resumeCartEnhance);
    select.addEventListener('change', function () {
      resumeCartEnhance();
      select.classList.remove('wearth-phase1-cart-size--invalid');
      var liveLine = Number(select.getAttribute('data-line') || line);
      var qty = Math.max(1, Number(item && item.quantity) || 1);
      changeCartVariant(liveLine, Number(select.value), qty, select, item);
    });
  }

  /* Colour option radios: Color (standard) OR Colourway (set bundles) */
  function colorOptionRadios() {
    return document.querySelectorAll('input.variant_name_color, input.variant_name_colourway');
  }

  function selectColorRadio(colorValue) {
    if (!colorValue) return;
    var radios = colorOptionRadios();
    radios.forEach(function (radio) {
      if (String(radio.value) === String(colorValue)) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function colorFromThumbnailTarget(target) {
    if (!target) return '';
    var src = '';
  if (target.tagName === 'IMG') src = target.getAttribute('src') || target.getAttribute('data-src') || '';
    else {
      var img = target.querySelector('img');
      if (img) src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    }
    if (!src) return '';
    var labels = document.querySelectorAll('label.image_change[data-variant-src]');
    for (var i = 0; i < labels.length; i += 1) {
      var labelSrc = labels[i].getAttribute('data-variant-src') || '';
      if (!labelSrc) continue;
      if (src.indexOf(labelSrc.replace(/^https?:/, '')) >= 0 || labelSrc.indexOf(src.replace(/^https?:/, '')) >= 0) {
        var inputId = labels[i].getAttribute('for');
        var input = inputId ? document.getElementById(inputId) : null;
        return input ? input.value : '';
      }
    }
    return '';
  }

  function initProductPage() {
    if (!isProductPage()) return;

    syncProductPageVariantState();

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches('input.variant_name_color, input.variant_name_colourway, input.variant_name_size, variant-radios input, variant-selects select')) return;
      if (target.matches('input.variant_name_color, input.variant_name_colourway') && productUsesPdpColorGallery()) {
        activateFirstPdpSlideForColor(target.value);
      }
      syncProductPageVariantState();
    });

    document.addEventListener('click', function (event) {
      var label = event.target.closest('label.image_change[data-variant-src]');
      if (label) {
        var inputId = label.getAttribute('for');
        var input = inputId ? document.getElementById(inputId) : null;
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        window.setTimeout(syncProductPageVariantState, 0);
        return;
      }

      var thumb = event.target.closest(
        '[id^="GalleryThumbnails-"] button, [id^="GalleryThumbnails-"] .thumbnail, .thumbnail-list__item button, .thumbnail-list__item'
      );
      if (thumb) {
        window.setTimeout(function () {
          if (!syncFromGalleryThumbnail(thumb)) {
            var color = colorFromThumbnailTarget(thumb);
            if (color) selectColorRadio(color);
          }
          syncProductPageVariantState();
        }, 0);
      }
    }, true);

    document.addEventListener('click', function (event) {
      /* Nuclear sticky owns its own click handler — do not hijack */
      if (event.target.closest('[data-wearth-sticky-submit], [data-wearth-sticky-bag]')) {
        return;
      }

      if (event.target.closest('.stickyCart .AddToCart, .stickyCart button[name="add"]')) {
        event.preventDefault();
        event.stopPropagation();
        resolveVariantIdForSubmit();
        submitMainProductAdd();
        return;
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.classList.contains('wearth-sticky-checkout__form')) {
        event.preventDefault();
        event.stopPropagation();
        resolveVariantIdForSubmit();
        submitMainProductAdd();
        return;
      }
      if (form.closest('.stickyCart')) {
        event.preventDefault();
        event.stopPropagation();
        resolveVariantIdForSubmit();
        submitMainProductAdd();
        return;
      }
      if (
        !form.closest('.stickyCart') &&
        !form.closest('product-form') &&
        !form.classList.contains('product-form')
      ) {
        return;
      }
      var variantId = resolveVariantIdForSubmit();
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && variantId) idInput.value = variantId;
    }, true);

    document.querySelectorAll('[id^="GalleryViewer-"]').forEach(function (viewer) {
      viewer.addEventListener('slideChanged', handleMediaGalleryChange);
      viewer.querySelectorAll('.slider-button').forEach(function (button) {
        button.addEventListener('click', function () {
          window.setTimeout(syncColorFromActiveGallery, 120);
        });
      });
    });
  }

  function findOptionKeys(product) {
    var hinted = { color: 'option1', size: 'option2' };
    (product.options || []).forEach(function (name, index) {
      var down = String(name).toLowerCase();
      var key = 'option' + (index + 1);
      if (down.indexOf('color') >= 0 || down.indexOf('colour') >= 0) hinted.color = key;
      if (down.indexOf('size') >= 0) hinted.size = key;
    });
    return inferKeysFromVariants(product.variants || [], hinted);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var product = data && data.id ? data : data.product;
        if (product) productCache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  /** Women's Everyday Joggers only: multi-angle gallery + correct Brown swatch in JS (Liquid/CSS already map Brown). */
  function joggersSetMainImage(card, url) {
    var img = card.querySelector('[data-wearth-phase1-image]');
    if (!img || !url) return;
    img.classList.add('wearth-phase1-image--changing');
    img.setAttribute('src', url);
    img.removeAttribute('srcset');
    window.setTimeout(function () {
      img.classList.remove('wearth-phase1-image--changing');
    }, 180);
  }

  function joggersBuildUrlsByColor(product, card) {
    var variants = parseVariants(card);
    if (!variants.length || !product) return {};
    var keys = inferOptionKeys(card, variants);
    var byColor = {};
    var vidToColor = {};
    variants.forEach(function (v) {
      vidToColor[String(v.id)] = String(variantOptionValue(v, keys.color) || '').trim();
    });
    variants.forEach(function (v) {
      var col = String(variantOptionValue(v, keys.color) || '').trim();
      if (!col) return;
      if (!byColor[col]) byColor[col] = [];
      if (v.featured_image && v.featured_image.src) {
        var u = v.featured_image.src;
        if (byColor[col].indexOf(u) < 0) byColor[col].push(u);
      }
    });
    var images = product.images || [];
    images.forEach(function (im) {
      var src = im && (im.src || (im.preview_image && im.preview_image.src));
      if (!src) return;
      var vids = im.variant_ids || [];
      vids.forEach(function (vid) {
        var col = vidToColor[String(vid)];
        if (!col) return;
        if (!byColor[col]) byColor[col] = [];
        if (byColor[col].indexOf(src) < 0) byColor[col].push(src);
      });
    });
    return byColor;
  }

  function applyJoggersSwatchFix(card) {
    getColorDots(card).forEach(function (dot) {
      var raw = (dot.getAttribute('data-color') || '').trim().toLowerCase();
      if (!raw) return;
      if (raw === 'brown' || raw === 'dark brown' || raw === 'chocolate' || raw === 'espresso') {
        dot.style.backgroundColor = '#4a3226';
      } else if (raw === 'black') {
        dot.style.backgroundColor = '#0b0b0b';
      } else if (raw === 'white' || raw === 'off white' || raw === 'off-white') {
        dot.style.backgroundColor = '#f7f4ee';
      }
    });
  }

  function hydrateCardVideoSources(video) {
    if (!video || video.getAttribute('data-wearth-src-ready') === '1') return;
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      if (!s.src) s.src = s.getAttribute('data-src');
    });
    video.setAttribute('data-wearth-src-ready', '1');
    try {
      video.load();
    } catch (e) {
      /* noop */
    }
  }

  function bindCardVideoPlaying(card, video) {
    if (!video || video.getAttribute('data-wearth-playing-bound') === '1') return;
    video.setAttribute('data-wearth-playing-bound', '1');
    function markPlaying() {
      video.classList.add('wearth-card-video--playing');
      if (card) card.classList.add('wearth-phase1-card--video-playing');
    }
    function unmarkPlaying() {
      video.classList.remove('wearth-card-video--playing');
      if (card) card.classList.remove('wearth-phase1-card--video-playing');
    }
    video.addEventListener('playing', markPlaying);
    video.addEventListener('loadeddata', markPlaying);
    video.addEventListener('pause', unmarkPlaying);
    video.addEventListener('emptied', unmarkPlaying);
  }

  function playCardHeroVideo(video, card) {
    if (!video || video.style.display === 'none') return;
    if (card) bindCardVideoPlaying(card, video);
    hydrateCardVideoSources(video);
    try {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {
      /* noop */
    }
  }

  function pauseCardHeroVideo(video) {
    if (!video) return;
    try {
      video.pause();
    } catch (e) {
      /* noop */
    }
  }

  function colorsMatch(a, b) {
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  function observeCardHeroVideo(card, video) {
    var prev = cardHeroVideoIO.get(card);
    if (prev && prev.disconnect) prev.disconnect();
    if (!video) {
      cardHeroVideoIO.delete(card);
      return;
    }
    if (typeof IntersectionObserver === 'undefined') {
      cardHeroVideoIO.set(card, { disconnect: function () {} });
      playCardHeroVideo(video, card);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        var on = entries[0] && entries[0].isIntersecting;
        if (!card.classList.contains('wearth-phase1-card--video-active')) return;
        if (on) playCardHeroVideo(video, card);
        else pauseCardHeroVideo(video);
      },
      { root: null, rootMargin: '60px 0px', threshold: 0.2 }
    );
    io.observe(card);
    cardHeroVideoIO.set(card, {
      disconnect: function () {
        try {
          io.disconnect();
        } catch (e2) {
          /* noop */
        }
      },
    });
  }

  function setCardHeroVideoSource(card, url) {
    var video = card.querySelector('[data-wearth-card-video]');
    if (!video || !url) return;
    pauseCardHeroVideo(video);
    var src = video.querySelector('source');
    if (src) {
      src.src = url;
      src.setAttribute('data-src', url);
    }
    video.setAttribute('data-wearth-src-ready', '0');
    hydrateCardVideoSources(video);
  }

  function syncCardHeroVideo(card, colorRaw, dot) {
    if (card.getAttribute('data-wearth-card-has-video') !== '1') return;
    var video = card.querySelector('[data-wearth-card-video]');
    if (!video) return;

    var hero = card.getAttribute('data-wearth-card-hero-color') || '';
    var videoUrl = (dot && dot.getAttribute('data-variant-video')) || '';
    var show =
      videoUrl ||
      (hero && colorsMatch(colorRaw, hero)) ||
      (dot && colorsMatch(dot.getAttribute('data-color'), hero));

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      show = false;
    }

    if (videoUrl) setCardHeroVideoSource(card, videoUrl);

    if (show) {
      video.style.display = '';
      card.classList.add('wearth-phase1-card--video-active');
      observeCardHeroVideo(card, video);
      bindCardVideoPlaying(card, video);
      playCardHeroVideo(video, card);
    } else {
      video.style.display = 'none';
      card.classList.remove('wearth-phase1-card--video-active');
      card.classList.remove('wearth-phase1-card--video-playing');
      pauseCardHeroVideo(video);
      observeCardHeroVideo(card, null);
    }
  }

  function initCardHeroVideo(card) {
    if (card.getAttribute('data-wearth-card-video-init') === '1') return;
    card.setAttribute('data-wearth-card-video-init', '1');

    var hero = card.getAttribute('data-wearth-card-hero-color') || '';
    var dots = getColorDots(card);
    var heroDot =
      dots.find(function (d) {
        return colorsMatch(d.getAttribute('data-color'), hero);
      }) || dots[0];
    if (heroDot) setCardColor(card, heroDot);

    if (window.matchMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      card.addEventListener('mouseenter', function () {
        var v = card.querySelector('[data-wearth-card-video]');
        if (v && card.classList.contains('wearth-phase1-card--video-active')) playCardHeroVideo(v, card);
      });
      card.addEventListener('mouseleave', function () {
        var v = card.querySelector('[data-wearth-card-video]');
        if (v) pauseCardHeroVideo(v);
      });
    }
  }

  function attachJoggersImageAngleCycler(card) {
    if (card.getAttribute('data-wearth-joggers-mv-click') === 'true') return;
    card.setAttribute('data-wearth-joggers-mv-click', 'true');
    var media = card.querySelector('[data-wearth-phase1-media]');
    if (!media) return;
    media.addEventListener(
      'click',
      function (event) {
        if (card.classList.contains('wearth-phase1-card--video-active')) return;
        if (!card._wearthJoggersUrlsByColor) return;
        var activeColor = (card.getAttribute('data-active-color') || '').trim();
        var urls = card._wearthJoggersUrlsByColor[activeColor];
        if (!urls || urls.length < 2) return;
        if (!event.target.closest('[data-wearth-phase1-image], img.wearth-phase1-image')) return;
        if (event.target.closest('[data-wearth-phase1-swipe-hint]')) return;
        event.preventDefault();
        event.stopPropagation();
        var idx = Number(card._wearthJoggersAngleIndex) || 0;
        idx += 1;
        if (idx >= urls.length) idx = 0;
        card._wearthJoggersAngleIndex = idx;
        joggersSetMainImage(card, urls[idx]);
      },
      true
    );
  }

  function initJoggersMultiview(card) {
    if (card.getAttribute('data-wearth-joggers-mv-boot') === '1') return;
    card.setAttribute('data-wearth-joggers-mv-boot', '1');
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;
    fetchProduct(handle).then(function (product) {
      if (!product) return;
      card._wearthJoggersUrlsByColor = joggersBuildUrlsByColor(product, card);
      attachJoggersImageAngleCycler(card);
      applyJoggersSwatchFix(card);
      var active = card.querySelector('[data-wearth-phase1-color-dot].is-active') || getColorDots(card)[0];
      if (active) setCardColor(card, active);
    });
  }

  function setCheckoutBlocked(blocked) {
    document.querySelectorAll('.ajaxcart .cart__checkout, .cart__checkout[name="checkout"]').forEach(function (button) {
      button.disabled = !!blocked;
      button.classList.toggle('wearth-phase1-checkout-blocked', !!blocked);
    });
  }

  function postCartJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      var ct = (response.headers.get('content-type') || '').toLowerCase();
      if (!ct.includes('application/json')) {
        return response.text().then(function (raw) {
          throw { message: 'non_json_cart_response', status: response.status, snippet: (raw || '').slice(0, 160) };
        });
      }
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function clearCartSizeError(select) {
    if (!select) return;
    var shell = select.closest('.wearth-phase1-cart-size');
    if (!shell) return;
    var err = shell.querySelector('[data-wearth-phase1-cart-size-error]');
    if (err) err.remove();
    select.classList.remove('wearth-phase1-cart-size--invalid');
  }

  function showCartSizeError(select, err) {
    if (!select) return;
    var shell = select.closest('.wearth-phase1-cart-size');
    if (!shell) return;
    var msg = (err && (err.description || err.message)) || 'Could not update size. Try again.';
    var el = shell.querySelector('[data-wearth-phase1-cart-size-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'wearth-phase1-cart-size__error';
      el.setAttribute('data-wearth-phase1-cart-size-error', '');
      shell.appendChild(el);
    }
    el.textContent = msg;
    select.classList.add('wearth-phase1-cart-size--invalid');
  }

  /** WEARTH_CART_SIZE_SWAP_ATOMIC — one /cart/update.js: old variant 0 + new variant qty. No empty gap. */
  function changeCartVariant(line, variantId, quantity, select, item) {
    if (!variantId) return;
    var newId = Number(variantId);
    var qty = Math.max(
      1,
      Number((select && select.getAttribute('data-line-qty')) || quantity) || 1
    );
    var oldVariant = Number(
      (select && select.getAttribute('data-variant-id')) ||
        (item && item.variant_id) ||
        0
    );
    if (oldVariant && newId === oldVariant) {
      select.disabled = false;
      return;
    }
    select.disabled = true;
    clearCartSizeError(select);
    pauseCartEnhance();

    var updates = {};
    updates[String(newId)] = qty;
    if (oldVariant) updates[String(oldVariant)] = 0;

    function applyAtomicSwap() {
      return postCartJson('/cart/update.js', { updates: updates });
    }

    function finishOk(cart) {
      var hasNew =
        cart &&
        cart.items &&
        cart.items.some(function (row) {
          return Number(row.variant_id) === newId && row.quantity >= qty;
        });
      if (!hasNew) throw { message: 'size_swap_not_applied' };

      if (select) {
        select.setAttribute('data-variant-id', String(newId));
        var match = (cart.items || []).find(function (row) {
          return Number(row.variant_id) === newId;
        });
        if (match) {
          if (match.key) select.setAttribute('data-line-key', String(match.key));
          select.setAttribute('data-line-qty', String(match.quantity || qty));
        }
      }

      latestCartSnapshot = cart;
      cartEnhanceSnapshot = '';
      cartEnhancePaused = 0;
      setCheckoutBlocked(false);
      select.disabled = false;
      resumeCartEnhance();
      refreshCartDrawer();
      window.setTimeout(function () {
        refreshCartDrawerLines(true);
      }, 400);
    }

    function finishErr(err) {
      select.disabled = false;
      resumeCartEnhance();
      setCheckoutBlocked(false);
      showCartSizeError(select, err);
      cartEnhanceSnapshot = '';
      cartEnhancePaused = 0;
      refreshCartDrawer();
      window.setTimeout(function () {
        refreshCartDrawerLines(true);
      }, 400);
    }

    applyAtomicSwap()
      .catch(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 350);
        }).then(applyAtomicSwap);
      })
      .then(finishOk)
      .catch(finishErr);
  }

  function enhanceCartLine(line, item, product) {
    var row = document.querySelector('.ajaxcart__row[data-line="' + line + '"]');
    if (!row) return;

    if (row.querySelector('[data-wearth-phase1-cart-size]')) return;

    var keys = findOptionKeys(product);
    var current = (product.variants || []).find(function (variant) {
      return Number(variant.id) === Number(item.variant_id);
    });
    if (!current) return;

    var color = variantOptionValue(current, keys.color);
    var sizes = sizesForColor(product.variants, color, keys);
    if (!sizes.length) return;

    var shell = document.createElement('div');
    shell.className = 'wearth-phase1-cart-size';

    var label = document.createElement('label');
    label.className = 'wearth-phase1-cart-size__label';
    label.textContent = 'Size';

    var select = document.createElement('select');
    select.className = 'wearth-phase1-cart-size__select';
    select.setAttribute('data-wearth-phase1-cart-size', '');
    select.setAttribute('data-line', String(line));
    if (item && item.key) select.setAttribute('data-line-key', String(item.key));
    if (item && item.variant_id) select.setAttribute('data-variant-id', String(item.variant_id));
    if (item && item.quantity) select.setAttribute('data-line-qty', String(item.quantity));

    sizes.forEach(function (entry) {
      var option = document.createElement('option');
      option.value = entry.id;
      option.textContent = entry.size + (entry.available ? '' : ' - Sold out');
      option.disabled = !entry.available;
      if (Number(entry.id) === Number(item.variant_id)) option.selected = true;
      select.appendChild(option);
    });

    if (!select.value) {
      select.classList.add('wearth-phase1-cart-size--invalid');
    }

    bindCartSizeSelect(select, line, item);

    label.appendChild(select);
    shell.appendChild(label);

    var anchor = row.querySelector('.ajaxcart__product-name');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(shell, anchor.nextSibling);
    } else {
      row.appendChild(shell);
    }
  }


  function syncFirstSetBundleNudge(cart) {
    /* WEARTH_FIRST_SET_BUNDLE_NUDGE — quiet line when Terra Bra + Biker Shorts sit apart */
    var footer = document.querySelector('#CartDrawer .ajaxcart__footer, #CartContainer .ajaxcart__footer, .ajaxcart__footer');
    if (!footer) return;
    var existing = footer.querySelector('[data-wearth-first-set-bundle-nudge]');
    var items = (cart && cart.items) || [];
    var hasTerra = false;
    var hasBiker = false;
    var hasSet = false;
    for (var i = 0; i < items.length; i++) {
      var h = items[i].handle || '';
      if (h === 'terra-sports-bra') hasTerra = true;
      if (h === 'womens-biker-shorts') hasBiker = true;
      if (h === 'the-first-set') hasSet = true;
    }
    var show = hasTerra && hasBiker && !hasSet;
    if (!show) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var p = document.createElement('p');
    p.className = 'wearth-first-set-bundle-nudge';
    p.setAttribute('data-wearth-first-set-bundle-nudge', '');
    p.innerHTML =
      'this pair is ₹699 less as <a href="/products/the-first-set">The First Set</a>.';
    var btn = footer.querySelector('.cart__checkout, button[name="checkout"]');
    if (btn && btn.parentNode === footer) {
      footer.insertBefore(p, btn);
    } else if (btn) {
      btn.parentNode.insertBefore(p, btn);
    } else {
      footer.appendChild(p);
    }
  }

  function enhanceCartFromSnapshot(force) {
    if (cartEnhanceInFlight) return;
    var cart = latestCartSnapshot;
    if (!cart) {
      refreshCartDrawerLines(force);
      return;
    }
    var items = cart.items || [];
    if (!items.length) {
      cartEnhanceSnapshot = '';
      setCheckoutBlocked(false);
      syncFirstSetBundleNudge(cart);
      return;
    }
    var signature = cartSignature(cart);
    if (!force && signature === cartEnhanceSnapshot) {
      syncFirstSetBundleNudge(cart);
      return;
    }
    cartEnhanceInFlight = true;
    Promise.all(
      items.map(function (item, index) {
        return fetchProduct(item.handle).then(function (product) {
          return { line: index + 1, item: item, product: product };
        });
      })
    )
      .then(function (entries) {
        cartEnhanceSnapshot = signature;
        entries.forEach(function (entry) {
          if (entry.product) enhanceCartLine(entry.line, entry.item, entry.product);
        });
        setCheckoutBlocked(false);
        syncFirstSetBundleNudge(cart);
      })
      .finally(function () {
        cartEnhanceInFlight = false;
      });
  }

  function refreshCartDrawerLines(force) {
    if (!force && cartEnhancePaused > 0) return;
    fetch('/cart.js')
      .then(function (response) {
        var ct = (response.headers.get('content-type') || '').toLowerCase();
        if (!response.ok || !ct.includes('application/json')) throw new Error('cart_js_bad_response');
        return response.json();
      })
      .then(function (cart) {
        latestCartSnapshot = cart;
        var items = cart.items || [];
        if (!items.length) {
          cartEnhanceSnapshot = '';
          setCheckoutBlocked(false);
          syncFirstSetBundleNudge(cart);
          return;
        }
        enhanceCartFromSnapshot(force);
      })
      .catch(function () {
        setCheckoutBlocked(false);
      });
  }

  function initAllCards(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wearth-phase1-card]').forEach(initCard);
  }

  function initDynamicCards() {
    document.addEventListener('rv:addedRecentlyViewedProduct', function () {
      initAllCards(document);
    });

    if (window.jQuery) {
      window.jQuery(document.body).on('afterRecommendationLoad', function () {
        initAllCards(document);
      });
    }

    if (typeof MutationObserver === 'undefined') return;

    var pending;
    var observer = new MutationObserver(function (mutations) {
      var hit = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-wearth-phase1-card]')) {
            hit = true;
            return;
          }
          if (node.querySelector && node.querySelector('[data-wearth-phase1-card]')) hit = true;
        });
      });
      if (!hit) return;
      if (pending) window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        initAllCards(document);
      }, 30);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initCartDrawer() {
    if (window.jQuery) {
      window.jQuery(document.body).on('afterCartLoad.ajaxCart', handleCartDrawerReady);
    }
  }

  function initAjaxCartTracking() {
    if (!window.jQuery) return;
    window.jQuery(document.body).on('afterAddItem.ajaxCart', function (_event, lineItem, source) {
      var card = null;
      if (source && source.nodeType === 1) {
        card = source.closest ? source.closest('[data-wearth-phase1-card]') : null;
      }
      trackAddToCartLine(lineItem, card, source);
    });
  }

  function init() {
    initAllCards(document);
    initDynamicCards();
    initProductPage();
    initCartDrawer();
    initAjaxCartTracking();
    initCheckoutRecovery();
    initCheckoutTracking();
    initBrowseTracking();
    document.documentElement.setAttribute('data-wearth-variant-phase1', PHASE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* WEARTH_VARIANT_PHASE1_END */

/* WEARTH_REAL_BODIES_LOADER */
(function () {
  var HANDLES = {
    "sleeveless-regular-fit-tshirt-men": 1,
    "womens-biker-shorts": 1,
    "womens-everyday-joggers": 1,
    "womens-power-crop": 1,
    "womens-tank-top": 1,
    "terra-sports-bra": 1
  };
  var ASSET_BASE = "/cdn/shop/t/35/assets/";
  var cfg = {
    css: ASSET_BASE + "seen-on-real-bodies.css",
    js: ASSET_BASE + "seen-on-real-bodies.js",
    map: ASSET_BASE + "seen-on-real-bodies-map.json"
  };
  function handle() {
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      return ShopifyAnalytics.meta.product.handle || "";
    }
    var c = document.querySelector('link[rel="canonical"]');
    if (c && c.href) {
      var p = c.href.split("/products/");
      if (p[1]) return p[1].split("?")[0];
    }
    return "";
  }
  function mainEl() {
    var n = document.querySelectorAll('[id^="shopify-section-"][id$="__main"]');
    return n.length ? n[n.length - 1] : null;
  }
  function go() {
    var h = handle();
    if (!HANDLES[h] || document.querySelector("[data-seen-real-bodies]")) return;
    var main = mainEl();
    if (!main) return;
    if (!document.querySelector("link[data-seen-real-css]")) {
      var l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = cfg.css;
      l.setAttribute("data-seen-real-css", "1");
      document.head.appendChild(l);
    }
    var sec = document.createElement("section");
    sec.className = "seen-real-bodies";
    sec.setAttribute("data-seen-real-bodies", "");
    sec.setAttribute("data-product-handle", h);
    sec.setAttribute("data-map-url", cfg.map);
    sec.setAttribute("data-interval", "4000");
    sec.innerHTML =
      '<div class="page-width seen-real-bodies__wrap"><header class="seen-real-bodies__header">' +
      '<h2 class="seen-real-bodies__title">Seen on real bodies</h2>' +
      '<p class="seen-real-bodies__sub">Not models. Real customers, real fit.</p></header>' +
      '<div class="seen-real-bodies__carousel" data-carousel>' +
      '<button type="button" class="seen-real-bodies__arrow seen-real-bodies__arrow--prev" data-prev aria-label="Previous slide">' +
      '<span aria-hidden="true">&#8592;</span></button>' +
      '<div class="seen-real-bodies__viewport" data-viewport><div class="seen-real-bodies__track" data-track></div></div>' +
      '<button type="button" class="seen-real-bodies__arrow seen-real-bodies__arrow--next" data-next aria-label="Next slide">' +
      '<span aria-hidden="true">&#8594;</span></button></div>' +
      '<div class="seen-real-bodies__dots" data-dots role="tablist" aria-label="Slide navigation"></div></div>';
    main.parentNode.insertBefore(sec, main.nextSibling);
    if (!document.querySelector("script[data-seen-real-js]")) {
      var s = document.createElement("script");
      s.src = cfg.js;
      s.defer = true;
      s.setAttribute("data-seen-real-js", "1");
      s.onload = function () {
        if (window.initSeenRealBodies) window.initSeenRealBodies();
      };
      document.body.appendChild(s);
    } else if (window.initSeenRealBodies) {
      window.initSeenRealBodies();
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", go);
  else go();
})();
/* WEARTH_PDP_DESKTOP_ATC_DEDUPE_JS */
(function () {
  function syncAtcSlots() {
    if (!document.body.classList.contains("template-product")) return;
    var desktop = document.querySelector("[data-wearth-pdp-desktop-atc]");
    var mobile = document.querySelector("[data-wearth-pdp-mobile-atc]");
    var buyAtc = document.querySelector(
      ".wearth-pdp-block--buy button.wearth-pdp-desktop-atc-btn"
    );
    var isDesktop = window.matchMedia("(min-width: 750px)").matches;
    if (desktop) desktop.style.display = isDesktop ? "" : "none";
    if (mobile) mobile.style.display = isDesktop ? "none" : "";
    if (buyAtc) buyAtc.style.display = isDesktop ? "none" : "";
  }
  function boot() {
    syncAtcSlots();
    window.addEventListener("resize", syncAtcSlots);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
